/**
 * Minimal Russian translation for react-admin (subset that we actually use).
 * Avoids pulling an extra dependency and gives full control over wording.
 */
const ru = {
  ra: {
    action: {
      add: "Добавить",
      add_filter: "Добавить фильтр",
      back: "Назад",
      bulk_actions: "1 выбран |||| %{smart_count} выбрано",
      cancel: "Отмена",
      clear_input_value: "Очистить",
      clone: "Клонировать",
      confirm: "Подтвердить",
      create: "Создать",
      create_item: "Создать %{item}",
      delete: "Удалить",
      edit: "Редактировать",
      export: "Экспорт",
      list: "Список",
      refresh: "Обновить",
      remove: "Удалить",
      remove_filter: "Убрать фильтр",
      remove_all_filters: "Очистить все фильтры",
      save: "Сохранить",
      search: "Поиск",
      select_all: "Выбрать всё",
      select_row: "Выбрать строку",
      show: "Открыть",
      sort: "Сортировка",
      undo: "Отменить",
      unselect: "Снять выделение",
      expand: "Развернуть",
      close: "Закрыть",
      open_menu: "Открыть меню",
      close_menu: "Закрыть меню",
      update: "Обновить",
      move_up: "Вверх",
      move_down: "Вниз",
      open: "Открыть",
      toggle_theme: "Сменить тему",
      select_columns: "Колонки",
    },
    boolean: { true: "Да", false: "Нет", null: " " },
    page: {
      create: "Создать %{name}",
      dashboard: "Панель",
      edit: "%{name} #%{id}",
      error: "Ошибка",
      list: "%{name}",
      loading: "Загрузка",
      not_found: "Не найдено",
      show: "%{name} #%{id}",
      empty: "Записей нет",
      invite: "Хотите создать первую?",
    },
    input: {
      file: { upload_several: "Перетащите файлы или нажмите", upload_single: "Перетащите файл или нажмите" },
      image: {
        upload_several: "Перетащите изображения или нажмите",
        upload_single: "Перетащите изображение или нажмите",
      },
      references: { all_missing: "Связанные записи не найдены", many_missing: "Часть записей не найдена", single_missing: "Связанная запись не найдена" },
      password: { toggle_visible: "Показать", toggle_hidden: "Скрыть" },
    },
    message: {
      about: "О программе",
      are_you_sure: "Вы уверены?",
      bulk_delete_content: "Удалить %{name}? |||| Удалить %{smart_count} записей?",
      bulk_delete_title: "Удалить %{name} |||| Удалить %{smart_count} записей",
      bulk_update_content: "Изменить %{name}? |||| Изменить %{smart_count} записей?",
      bulk_update_title: "Изменить %{name} |||| Изменить %{smart_count} записей",
      delete_content: "Удалить запись?",
      delete_title: "Удалить %{name} #%{id}",
      details: "Детали",
      error: "Произошла ошибка, операция не выполнена",
      invalid_form: "Форма заполнена с ошибками",
      loading: "Загрузка...",
      no: "Нет",
      not_found: "Запись не найдена",
      yes: "Да",
      unsaved_changes: "Есть несохранённые изменения. Уйти?",
    },
    navigation: {
      no_results: "Ничего не найдено",
      no_more_results: "Это последняя страница",
      page_out_of_boundaries: "Страница %{page} вне диапазона",
      page_out_from_end: "Конец списка",
      page_out_from_begin: "Начало списка",
      page_range_info: "%{offsetBegin}-%{offsetEnd} из %{total}",
      page_rows_per_page: "На странице:",
      next: "Следующая",
      prev: "Предыдущая",
      previous: "Предыдущая",
      skip_nav: "Перейти к содержимому",
    },
    sort: { sort_by: "Сортировать по %{field} %{order}", ASC: "по возрастанию", DESC: "по убыванию" },
    auth: {
      auth_check_error: "Требуется авторизация",
      user_menu: "Профиль",
      username: "Email или телефон",
      password: "Пароль",
      sign_in: "Войти",
      sign_in_error: "Ошибка авторизации",
      logout: "Выйти",
    },
    notification: {
      updated: "Сохранено |||| %{smart_count} записей обновлено",
      created: "Создано",
      deleted: "Удалено |||| %{smart_count} записей удалено",
      bad_item: "Некорректная запись",
      item_doesnt_exist: "Запись не существует",
      http_error: "Ошибка сервера",
      data_provider_error: "Ошибка сервера",
      i18n_error: "Невозможно загрузить перевод",
      canceled: "Отменено",
      logged_out: "Сессия истекла, войдите снова",
      not_authorized: "Нет прав для этого действия",
    },
    validation: {
      required: "Обязательное поле",
      minLength: "Минимум %{min} символов",
      maxLength: "Максимум %{max} символов",
      minValue: "Минимум %{min}",
      maxValue: "Максимум %{max}",
      number: "Должно быть числом",
      email: "Некорректный email",
      oneOf: "Допустимо: %{options}",
      regex: "Не соответствует формату %{pattern}",
    },
    saved_queries: { label: "Сохранённые поиски", query_name: "Название", new_label: "Сохранить...", new_dialog_title: "Сохранить поиск", remove_label: "Удалить", remove_label_with_name: "Удалить %{name}", remove_dialog_title: "Удалить?" },
    configurable: { customize: "Настроить" },
  },
};

export default ru;
